<template>
	<button @click.stop="incrementSpeed">
		{{ speed }}x
	</button>
</template>

<script>
export default {
	props: ['speed', 'player'],
	methods: {
		incrementSpeed() {
			let player = this.player
			// The slot exposes `player` as `this.$refs.player`, which is null on
			// the first render pass — clicking the chip before the <audio>
			// element resolved threw on `null.playbackRate`.
			if (!player) return
			let proposedSpeed = 1
			if (this.canIncreaseSpeed) {
				proposedSpeed = this.speed + 0.25
			} else {
				proposedSpeed = 0.75
			}
			// 1 + 0.25 + 0.25 … accumulates binary error, and the label prints
			// the raw number ("1.7500000000000002x").
			player.playbackRate = Math.round(proposedSpeed * 100) / 100
		},
	},
	computed: {
		canIncreaseSpeed() {
			return this.speed < 2
		},
		canDecreaseSpeed() {
			return this.speed > 0.75
		}
	}
}
</script>
